import React, { useState } from "react";
import Slider from "react-slick";

import CreditLine from "../images/line-credit.png";
import EarnedWage from "../images/earned-wage.png";
import PersonalLoan from "../images/personal-loan.png";
import "../styles/custom-carousel.scss";

const settings = {
  infinite: true, //to allow the slides to show infinitely
  lazyLoad: true,
  speed: 300, //this is the speed of slider in ms
  slidesToShow: 3, //number of slides to show up on screen
  centerMode: true,
  centerPadding: 0,
  dots: false,
  arrows: false,
};

const SolutionSlider = (props) => {
  const { imgIndex, setImgIndex } = props;
  const images = [
    EarnedWage,
    CreditLine,
    PersonalLoan,
    EarnedWage,
    CreditLine,
    PersonalLoan,
  ];

  settings.beforeChange = (current, next) => setImgIndex(next);

  return (
    <div className="customCarousel">
      <Slider {...settings}>
        {images.map((img, idx) => (
          <div className={idx === imgIndex ? "slide activeSlide" : "slide"}>
            <img src={img} alt={idx} />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default SolutionSlider;
